package de.oevbs.kunde.kundenportal2.model.services.account

import de.oevbs.kunde.kundenportal2.validation.KupoValidationMessages
import de.oevbs.kunde.kundenportal2.validation.Regexes
import dev.fritz2.core.Lenses
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.headless.validation.errorMessage
import dev.fritz2.validation.validation
import kotlinx.serialization.Serializable

data class UserName(val name: String = "")

@Lenses
@Serializable
data class ChangePassword(
    val currentPassword: String = "",
    val newPassword: String = "",
    val newPasswordRepeat: String = "",
) {
    companion object {

        val validation = validation<ChangePassword, UserName, ComponentValidationMessage> { inspector, username ->

            val pass = inspector.map(ChangePassword.currentPassword())
            if (pass.data.isEmpty()) {
                add(pass.errorMessage("Bitte geben Sie Ihr aktuelles Passwort ein."))
            }

            val newPass = inspector.map(ChangePassword.newPassword())
            if (newPass.data.isEmpty()) {
                add(newPass.errorMessage("Bitte geben Sie Ihr neues Passwort ein."))
            } else if (!Regexes.password.matches(newPass.data)) {
                add(newPass.errorMessage(KupoValidationMessages.NO_MATCH_HELP))
            } else if (username.name.isNotEmpty() && newPass.data.contains(username.name)) {
                add(newPass.errorMessage("Ihr Passwort darf nicht Ihren Benutzernamen enthalten - klicken Sie auf das Fragezeichen, um Hilfe zu erhalten."))
            }

            val newPassRepeat = inspector.map(ChangePassword.newPasswordRepeat())
            if (newPassRepeat.data.isEmpty()) {
                add(newPassRepeat.errorMessage("Bitte wiederholen Sie Ihr neues Passwort."))
            } else if (newPassRepeat.data != newPass.data) {
                add(newPassRepeat.errorMessage("Die Passwörter stimmen nicht überein."))
            }
        }
    }
}